// extracted by mini-css-extract-plugin
export var product = "CartItem-module--product--vuqhq";
export var title = "CartItem-module--title--bmBUu";
export var subtitle = "CartItem-module--subtitle--9m1uG";
export var seats = "CartItem-module--seats--ol07J";
export var priceContainer = "CartItem-module--priceContainer--sIX8m";
export var price = "CartItem-module--price--t3chm";
export var unitPrice = "CartItem-module--unitPrice--9b0Ok";
export var deleteItem = "CartItem-module--deleteItem--modgs";